export default function getLinks(state, props, hide = []) {
    const { pages, locale = {}, config } = state
    const { userSummary = {} } = props
    const { id: localeId, language, country } = locale
    const { loyaltySegment, loyaltyConsent } = userSummary ? userSummary : {}

    return pages.reduce((acc, page) => {
        const { id } = page

        // Exclude pages that belong to exclusion list
        if (hide.includes(id)) return acc

        // Exclude pages that are dependent on some condition
        if (id === 'reservations' && !userSummary?.reservationCountTotal) return acc;
        
        if (id === 'referAFriend') {
            const { head = {} } = config
            const { buyapowaEnabledCountries = [], buyapowaURL, buyapowaCampaign, buyapowaEnableAllCountries } = head
            const buyapowaEnabled =
                (buyapowaEnabledCountries.includes(country) || buyapowaEnableAllCountries) && buyapowaCampaign && buyapowaURL
            if (!buyapowaEnabled) return acc;
        }

        if (id === 'rewardsProgram') {
            if (loyaltyConsent === 'true' && loyaltySegment) return [...acc, { ...page, href: null, to: `/${localeId}${page.optedInPath}` }]
            return [...acc, { ...page, href: page.href.replace('{language}', language).replace('{country}', country?.toLowerCase())}]
        }

        const pageLink = { ...page }
        if (page.to) pageLink.to = `/${localeId}${page.to}`
        if (page.href) pageLink.href = page.href.replace('{language}', language).replace('{country}', country?.toLowerCase())
        return [...acc, pageLink]
    }, [])
}
